import { render, staticRenderFns } from "./SupportHubs.vue?vue&type=template&id=4c0d29ab&"
import script from "./SupportHubs.vue?vue&type=script&lang=js&"
export * from "./SupportHubs.vue?vue&type=script&lang=js&"
import style0 from "./SupportHubs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports